import * as Yup from 'yup';

export default Yup.object({
  groupRoleDescId: Yup.string().required('Please select a link type'),
});
